import { Button, cn } from '@nextui-org/react'
import { Link, useMatch } from 'react-router-dom'

export interface MenuItem {
  icon?: React.ReactNode
  onPress?: () => void
  title: string
  to?: string
}

export function MenuItem({ icon, onPress, title, to = '' }: MenuItem) {
  const match = useMatch(to) !== null

  return (
    <Button
      as={Link}
      className={cn('justify-start py-6 text-left font-medium uppercase', {
        'text-default-600': !match,
        'text-white': match,
      })}
      color={match ? 'primary' : 'default'}
      fullWidth
      onPress={onPress}
      startContent={icon}
      to={to}
      variant={match ? 'solid' : 'light'}
    >
      {title}
    </Button>
  )
}

export default MenuItem
